import type { LineItemOverride } from '@techgitter/contracts';

/**
 * How a no-charge line is priced in RepairShopr, and how its rate comes back.
 *
 * The form keeps a no-charge line's rate in `unitCost` and zeroes only the
 * displayed total. An RS ticket line has no discount field, so the line must
 * reach RS at `price_retail: 0` — sending the rate bills it in full. The rate
 * is kept in the line's metadata (`chargeableUnitCost`) so a reopened ticket
 * still shows it and unticking No charge bills the right amount, including a
 * per-customer pricing-profile rate the catalog alone would not give back.
 *
 * sm4rt-api's `build_orchestrator_payload` applies the same rule on ticket
 * creation; change them together.
 */

/** The `price_retail` RepairShopr should hold for a form line. */
export function rsPriceRetail(item: { unitCost: number; nonChargeable: boolean }): number {
  return item.nonChargeable ? 0 : item.unitCost;
}

/** The form's `unitCost` for an RS line, restoring a no-charge line's rate. */
export function hydratedUnitCost(
  rsPriceRetailValue: number,
  override: LineItemOverride | undefined,
): number {
  if (override?.nonChargeable && typeof override.chargeableUnitCost === 'number') {
    return override.chargeableUnitCost;
  }
  return rsPriceRetailValue;
}
